import { i18n } from "../../../boot/i18n";

import commission from "./commission";
import heldPay from "./heldPay";
import paycheck from "./paycheck";
import payrollHistory from "./payrollHistory";

const children = [
  ...commission.routes,
  ...heldPay.routes,
  ...paycheck.routes,
  ...payrollHistory.routes,
];

export default {
  routes: [
    {
      name: "payroll",
      path: "payroll",
      component: () => import("pages/accounting/payroll/Index"),
      meta: {
        auth: () =>
          children.some((route) => route.meta.auth && route.meta.auth()),
        icon: "payroll",
        title: i18n.global.t("Payroll"),
        crumbs: ["accounting"],
        color: "primary",
      },
      children,
    },
  ],

  dialogs: [
    ...commission.dialogs,
    ...heldPay.dialogs,
    ...paycheck.dialogs,
    ...payrollHistory.dialogs,
  ],
};
